import React from 'react'
import { BLOCKS, INLINES } from '@contentful/rich-text-types'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import get from 'lodash/get'
import Section from '../components/Section'
import Quote from '../../giesswein-headless-components/src/components/Quote/Quote'
import Gallery from '../../giesswein-headless-components/src/components/Gallery/Gallery'
import ImageCardGrid from '../../giesswein-headless-components/src/components/ImageCard/ImageCardGrid'
import { TEXT_POSITION } from '../../giesswein-headless-components/src/components/ImageCard/ImageCard'
import Video from '../../giesswein-headless-components/src/components/Video/Video'
import LandingPageEcco from '../../giesswein-headless-components/src/components/LandingPageEcco/LandingPageEcco'
import LandingPageMerinoRunners from '../../giesswein-headless-components/src/components/LandingPageMerinoRunners/LandingPageMerinoRunners'
import {
  MerinoWool1,
  MerinoWool2,
} from '../../giesswein-headless-components/src/components/LandingPageMerinoWool'
import {
  WoolCross1,
  WoolCross2,
} from '../../giesswein-headless-components/src/components/LandingPageWoolCross'
import WoolSneaker from '../../giesswein-headless-components/src/components/LandingPageWoolSneaker'
import {
  selectLocaleInNestedObject,
  getBlogPostUrl,
  getProductUrl,
} from '../helpers'
import { t } from '../../giesswein-headless-components/src/helper'
import { LandingPageWoolPops } from '../../giesswein-headless-components/src/components/LandingPageWoolPops'
import {
  LandingPageWoodSneaker1,
  LandingPageWoodSneaker2,
} from '../../giesswein-headless-components/src/components/LandingPageWoodSneaker/'
import { styles as buttonStyles } from '../../giesswein-headless-components/src/components/Button/styled-components'
import Buttons from '../../giesswein-headless-components/src/components/Buttons/Buttons'
import ImageWithText, {
  imagePositions,
} from '../../giesswein-headless-components/src/components/ImageWithText/ImageWithText'
import Image from '../../giesswein-headless-components/src/components/Image/Image'
import LandingPageXapine from '../../giesswein-headless-components/src/components/LandingPageXapine/LandingPageXapine'

function renderSections(node, children) {
  const fields = selectLocaleInNestedObject(
    get(node, 'data.target.fields') || {}
  )
  const type =
    get(node, 'data.target.sys.contentType.sys.id') || get(node, 'nodeType')
  let component
  let props

  // Filter empty elements
  if (Array.isArray(children) && type !== 'embedded-asset-block') {
    const childrenLength = children
      .map(child => {
        return Array.isArray(child) ? child.filter(Boolean) : [true]
      })
      .filter(arr => arr.length > 0).length

    if (childrenLength <= 0 && Object.values(BLOCKS).includes(type)) {
      return []
    }
  }

  switch (type) {
    case BLOCKS.PARAGRAPH:
      component = children.length > 0 ? <p>{children}</p> : []
      break
    case BLOCKS.UL_LIST:
      component = <ul className="bullet">{children}</ul>
      break
    case BLOCKS.EMBEDDED_ASSET:
      const { title, description, file } = fields
      const mimeType = file.contentType
      const mimeGroup = mimeType.split('/')[0]

      switch (mimeGroup) {
        case 'image':
          component = <img title={title} alt={description} src={file.url} />
          break
        default:
          component = []
      }
      break
    case 'quote':
      component = (
        <Quote
          {...fields}
          typeName={fields.type}
          text={documentToReactComponents(fields.text)}
        />
      )
      break
    case 'gallery':
      fields.images = fields.img.map(img =>
        selectLocaleInNestedObject(get(img, 'fields') || {})
      )
      component = <Gallery {...fields} />
      break
    case 'relatedBlogPosts':
      const items = fields.blocks
        ? fields.blocks.map(block => {
            const blockFields = mapContentfulToFields(block.fields)

            // Blockpost
            if (blockFields.blog) {
              return {
                image: blockFields.previewImage || blockFields.image,
                title: blockFields.title,
                urlTitle: t('readMore', process.env.GATSBY_LOCALE),
                url: `/blogs/${(blockFields.blog && blockFields.blog.slug) ||
                  'news'}/${blockFields.slug}`,
              }
            }

            // Custom Block
            return {
              image: blockFields.image,
              title: blockFields.title,
              urlTitle: blockFields.linkTitle,
              url: blockFields.linkUrl,
            }
          })
        : []

      component = (
        <ImageCardGrid
          {...fields}
          textPosition={TEXT_POSITION[fields.position] || TEXT_POSITION.default}
          stretch={false}
          center={items.length < 3}
          items={items}
        />
      )
      break
    case 'video':
      const videoData = {
        videoId: fields.videoId,
        poster: get(fields, 'poster.fields.file.url'),
        format: fields.format,
      }

      component = <Video type="youtube" videoData={videoData} />
      break
    case 'customHtml':
      component = <div dangerouslySetInnerHTML={{ __html: fields.html }} />
      break

    case 'subButtons':
      const buttons = []

      for (let i = 1; i <= 3; i++) {
        if (fields['buttonText' + i]) {
          buttons.push({
            title: fields['buttonText' + i],
            url: fields['buttonUrl' + i],
          })
        }
      }

      component = (
        <Buttons
          buttonStyle={buttonStyles[fields['buttonStyle']]}
          buttons={buttons}
        />
      )
      break

    case 'imageWithText':
      props = {
        text: toReactComponents(get(fields, 'text')),
        imageUrl: get(fields, 'image.fields.file.url'),
        imagePosition:
          imagePositions[fields.imagePosition] || imagePositions.LEFT,
      }

      component = <ImageWithText {...props} />
      break
    // case 'imageText':
    //   const imageTextData = {
    //     container: fields.container,
    //     stretched: fields.fullWidth,
    //     mediaUrl: get(fields, 'image.fields.file.url'),
    //     mediaUrlMobile: get(fields, 'imageMobile.fields.file.url') || get(fields, 'image.fields.file.url'),
    //     text: documentToReactComponents(fields.text),
    //     sectionStyle: sectionStyles[fields.sectionStyle],
    //     textPosition: textPositions[fields.textPosition],
    //     textPositionMobile: textPositions[fields.textPositionMobile || fields.textPosition],
    //     imagePosition: imagePositions[fields.imagePosition],
    //     imagePositionMobile: imagePositions[fields.imagePositionMobile || fields.imagePosition],
    //     textColor: fields.textColor,
    //     buttons: [],
    //   };

    //   for(let i = 1; i <= 3; i++) {
    //     if(fields['buttonText' + i]) {
    //       imageTextData.buttons.push({
    //         text: fields['buttonText' + i],
    //         buttonStyle: buttonStyles[fields['buttonStyle' + i]],
    //         url: fields['buttonUrl' + i]
    //       });
    //     }
    //   }

    //   component = <ImageTextSection {...imageTextData} />
    //   break;
    case 'landingpageEcco':
      props = Object.assign({}, fields, {
        locale: process.env.GATSBY_LOCALE,
        headerText: toReactComponents(get(fields, 'headerText')),
        headerBackgroundMobile: get(
          fields,
          'headerBackgroundMobile.fields.file.url'
        ),
        headerBackground: get(fields, 'headerBackground.fields.file.url'),
        headerBackgroundMobile1: get(
          fields,
          'headerBackgroundMobile1.fields.file.url'
        ),
        headerBackgroundMobile2: get(
          fields,
          'headerBackgroundMobile2.fields.file.url'
        ),
        section1Text: toReactComponents(get(fields, 'section1text')),
        soleFeaturesText1: documentToReactComponents(
          get(fields, 'soleFeaturesText1')
        ),
        soleFeaturesText2: documentToReactComponents(
          get(fields, 'soleFeaturesText2')
        ),
        soleFeaturesText3: documentToReactComponents(
          get(fields, 'soleFeaturesText3')
        ),
        soleFeaturesText4: documentToReactComponents(
          get(fields, 'soleFeaturesText4')
        ),
        sec2Text: toReactComponents(get(fields, 'sec2text')),
        sec2BackgroundMobile: get(
          fields,
          'sec2backgroundMobile.fields.file.url'
        ),
        sec2Background: get(fields, 'sec2background.fields.file.url'),
        sec2ButtonText1: fields.sec2buttonText1,
        sec2ButtonText2: fields.sec2buttonText2,
        sec2ButtonUrl1: fields.sec2buttonUrl1,
        sec2ButtonUrl2: fields.sec2buttonUrl2,
        sec3Text: toReactComponents(get(fields, 'sec3text')),
        sec3ButtonText: fields.sec3buttonText,
        sec3ButtonUrl: fields.sec3buttonUrl,
        sec3Title: fields.sec3title,
        sec4Text: toReactComponents(get(fields, 'sec4text')),
        sec5BackgroundMobile: get(
          fields,
          'sec5backgroundMobile.fields.file.url'
        ),
        sec5Background: get(fields, 'sec5background.fields.file.url'),
        sec5Text: toReactComponents(get(fields, 'sec5text')),
        sec5ButtonText1: fields.sec5buttonText1,
        sec5ButtonText2: fields.sec5buttonText2,
        sec5ButtonUrl1: fields.sec5buttonUrl1,
        sec5ButtonUrl2: fields.sec5buttonUrl2,
        sec6BackgroundMobile: get(
          fields,
          'sec6backgroundMobile.fields.file.url'
        ),
        sec6Background: get(fields, 'sec6background.fields.file.url'),
        sec6Text: toReactComponents(get(fields, 'sec6text')),
        sec6ButtonText: fields.sec6buttonText,
        sec6ButtonUrl: fields.sec6buttonUrl,
        sec8Image: get(fields, 'sec8image.fields.file.url'),
        sec8Text: toReactComponents(get(fields, 'sec8text')),
        sec8ButtonText: fields.sec8buttonText,
        sec8ButtonUrl: fields.sec8buttonUrl,
      })

      component = <LandingPageEcco {...props} />
      break
    case 'landingpageMerinoWool':
      props = Object.assign({}, fields, {
        bannerText: toReactComponents(get(fields, 'bannerText')),
        bannerImage: get(fields, 'bannerImage.fields.file.url'),
        bannerImageMobile: get(fields, 'bannerImageMobile.fields.file.url'),
        shoeLayersText: toReactComponents(get(fields, 'shoeLayersText')),
        sec3Text: toReactComponents(get(fields, 'sec3Text')),
        sec4Text: toReactComponents(get(fields, 'sec4Text')),
        sec5Text: toReactComponents(get(fields, 'sec5Text')),
        shoeModelImage: get(fields, 'shoeModelImage.fields.file.url'),
        bgSec3: get(fields, 'bgSec3.fields.file.url'),
        bgSec3Mobile: get(fields, 'bgSec3Mobile.fields.file.url'),
        bgSec4: get(fields, 'bgSec4.fields.file.url'),
        bgSec4Mobile: get(fields, 'bgSec4Mobile.fields.file.url'),
        bgSec5Mobile: get(fields, 'bgSec5Mobile.fields.file.url'),
        bgSec5: get(fields, 'bgSec5.fields.file.url'),
        bgSec5Uhd: get(fields, 'bgSec5Uhd.fields.file.url'),
      })

      component = <MerinoWool1 {...props} />
      break
    case 'landingPageMerinoWool2':
      props = Object.assign({}, fields, {
        bgSec8: get(fields, 'bgSec8.fields.file.url'),
        bgSec8Mobile: get(fields, 'bgSec8Mobile.fields.file.url'),
        bgSec10: get(fields, 'bgSec10.fields.file.url'),
        bgSec10Mobile: get(fields, 'bgSec10Mobile.fields.file.url'),
        bgSec11: get(fields, 'bgSec11.fields.file.url'),
        bgSec11Mobile: get(fields, 'bgSec11Mobile.fields.file.url'),
        bgSec12: get(fields, 'bgSec12.fields.file.url'),
        bgSec12Mobile: get(fields, 'bgSec12Mobile.fields.file.url'),
        testimonialShoeImage: get(
          fields,
          'testimonialShoeImage.fields.file.url'
        ),
        regulateFootTemperatureText: toReactComponents(
          get(fields, 'regulateFootTemperatureText')
        ),
        shoeDotsText: toReactComponents(get(fields, 'shoeDotsText')),
        footBedText: toReactComponents(get(fields, 'footBedText')),
        easyCleaningText: toReactComponents(get(fields, 'easyCleaningText')),
        sheepText: toReactComponents(get(fields, 'sheepText')),
        testimonialText: toReactComponents(get(fields, 'testimonialText')),
      })

      component = <MerinoWool2 {...props} />
      break

    case 'landingpageMerinoRunners':
      props = Object.assign({}, fields, {
        headerBackgroundMobile: get(
          fields,
          'headerBackgroundMobile.fields.file.url'
        ),
        headerBackground: get(fields, 'headerBackground.fields.file.url'),
        headerText: toReactComponents(get(fields, 'headerText')),
        headerTextSmall: toReactComponents(get(fields, 'headerTextSmall')),
        sec1Text: toReactComponents(get(fields, 'sec1Text')),
        sec2Text: toReactComponents(get(fields, 'sec2Text')),
        sec2BackgroundMobile: get(
          fields,
          'sec2BackgroundMobile.fields.file.url'
        ),
        sec2Background: get(fields, 'sec2Background.fields.file.url'),
        sec3Text: toReactComponents(get(fields, 'sec3Text')),
        sec4Text: toReactComponents(get(fields, 'sec4Text')),
        sec4Details1: documentToReactComponents(get(fields, 'sec4Details1')),
        sec4Details2: documentToReactComponents(get(fields, 'sec4Details2')),
        sec4Details3: documentToReactComponents(get(fields, 'sec4Details3')),
        sec4Details4: documentToReactComponents(get(fields, 'sec4Details4')),
        sec5Text: toReactComponents(get(fields, 'sec5Text')),
        sec5BackgroundMobile: get(
          fields,
          'sec5BackgroundMobile.fields.file.url'
        ),
        sec5Background: get(fields, 'sec5Background.fields.file.url'),
        sec6Text: toReactComponents(get(fields, 'sec6Text')),
        sec6BackgroundMobile: get(
          fields,
          'sec6BackgroundMobile.fields.file.url'
        ),
        sec6Background: get(fields, 'sec6Background.fields.file.url'),
        sec7Text: toReactComponents(get(fields, 'sec7Text')),
        sec7BackgroundMobile: get(
          fields,
          'sec7BackgroundMobile.fields.file.url'
        ),
        sec7Background: get(fields, 'sec7Background.fields.file.url'),
        sec8Text: toReactComponents(get(fields, 'sec8Text')),
        sec8Image: get(fields, 'sec8Image.fields.file.url'),
      })

      component = <LandingPageMerinoRunners {...props} />
      break

    case 'subLandingpageWoolCross1':
      props = Object.assign({}, mapContentfulToFields(fields), {
        bannerShoeLayer: get(fields, 'bannerShoeLayer.fields.file.url'),
      })

      component = <WoolCross1 {...props} />
      break

    case 'subLandingpageWoolCrossPart2':
      props = Object.assign({}, mapContentfulToFields(fields), {
        bannerShoeLayer: get(fields, 'bannerShoeLayer.fields.file.url'),
      })

      component = <WoolCross2 {...props} />
      break

    case 'subLandingpageSneaker':
      props = Object.assign({}, mapContentfulToFields(fields))

      component = <WoolSneaker {...props} />
      break

    case 'subLandingpageWoodSneaker':
      props = mapContentfulToFields(fields)
      component = <LandingPageWoodSneaker1 {...props} />
      break

    case 'subLandingpageWoodSneaker2':
      props = mapContentfulToFields(fields)
      component = <LandingPageWoodSneaker2 {...props} />
      break
    case 'landingpageWoolpops':
      props = mapContentfulToFields(fields)
      component = <LandingPageWoolPops {...props} />
      break

    case 'landingpageXalpine':
      props = mapContentfulToFields(fields)
      component = <LandingPageXapine {...props} />
      break

    case 'subImage':
      props = mapContentfulToFields(fields)
      component = <Image {...props} />
      break

    case 'text':
      component = <div dangerouslySetInnerHTML={{ __html: fields.text }} />
      break

    default:
      console.log(`No component found for type ${type}`)
      console.log(fields)
      component = []
  }

  if (type !== BLOCKS.PARAGRAPH) {
    return <Section>{component}</Section>
  } else {
    return component
  }
}

const options = {
  renderNode: {
    [BLOCKS.EMBEDDED_ENTRY]: renderSections,
    [BLOCKS.UL_LIST]: renderSections,
    [BLOCKS.PARAGRAPH]: renderSections,
    [INLINES.EMBEDDED_ENTRY]: renderSections,
    [BLOCKS.EMBEDDED_ASSET]: renderSections,
  },
  // Replace \n with <br />
  renderText: text => {
    return text.split('\n').reduce((children, textSegment, index) => {
      return [...children, index > 0 && <br key={index} />, textSegment]
    }, [])
  },
}

/**
 * Automatically map fields from Contentful to image & text
 * @param {Object} fields
 */
function mapContentfulToFields(fields) {
  const newFields = {}

  Object.keys(fields).forEach(key => {
    const keyLowercased = key.toLowerCase()

    if (
      keyLowercased.includes('image') ||
      keyLowercased.includes('background') ||
      keyLowercased.includes('bg')
    ) {
      newFields[key] = get(fields[key], 'fields.file.url')
    } else if (
      (keyLowercased.includes('text') ||
        keyLowercased.includes('content') ||
        keyLowercased.includes('title') ||
        keyLowercased.includes('fact') ||
        keyLowercased.includes('heading')) &&
      !keyLowercased.includes('button')
    ) {
      if (typeof fields[key] === 'string' || fields[key] instanceof String) {
        newFields[key] = (
          <div dangerouslySetInnerHTML={{ __html: fields[key] }} />
        )
      } else {
        newFields[key] = toReactComponents(fields[key])
      }
    } else {
      newFields[key] = fields[key]
    }
  })

  return newFields
}

export function toReactComponents(json) {
  return documentToReactComponents(json, options)
}

export default function SectionRenderer(props) {
  const { json } = props

  return <React.Fragment>{toReactComponents(json)}</React.Fragment>
}
